// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"332c7cf1","743":"b6f77c11","917":"fe8f052e"}[chunkId] + ".chunk.js";
};